module.exports = __webpack_public_path__ + "static/media/logosquare.7325e2e9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logosquare.png
// module id = 712
// module chunks = 0